<template>
<v-app id="inspire" style="background: #f8f9fa">
  <div class="pr-6 pl-6 pb-8">
    <titleAgency></titleAgency>
    <v-tabs
      v-model="tab"
      color="#2BA197"
      background-color="titlebackground"
    >
    <v-tabs-slider class="ml-0" color="#2BA197"></v-tabs-slider>
    <v-tab v-for="item in items" :key="item.nameBusiness" style="font-weight: 700;font-size: 16px;letter-spacing: 1px;">
      <span class="ml-0">{{ item.nameBusiness }}</span>
    </v-tab>

    <v-tabs-items v-model="tab" style="border-radius: 16px;" class="pb-5">
      <!-- tab จัดการธุรกิจ -->
      <v-tab-item>
        <div class="my-5"
        >
          <div>
            <filterBusiness class="mx-5 mt-0"/>
            <tablebusiness class="mx-5 mb-5"/>
          </div>
        </div>
      </v-tab-item>
      <!-- tab ลงทะเบียนธุรกิจ -->
      <v-tab-item>
        <div class="my-5" style="border-radius: 16px;">
          <div>
            <filterRegisterBusiness class="mx-5 mt-5"/>
            <tableRegisterBusiness class="mx-5 mb-5"/>
          </div>
        </div>
      </v-tab-item>
      <!-- tab ยื่นเรื่องเปลี่ยนแปลงธุรกิจ -->
      <v-tab-item>
        <div class="my-5" style="border-radius: 16px;">
          <div>
            <filterChangeBusiness class="mx-5 mt-5"/>
            <tableChangeBusiness class="mx-5 mb-5"/>
          </div>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </v-tabs>
</div>
</v-app>
</template>

<script>
import { EventBus } from '@/EventBus'
import titleAgency from '@/components/_managebusinessnew/_overview/title.vue'
import filterBusiness from '@/components/_managebusinessnew/_overview/filterbusiness.vue'
import filterRegisterBusiness from '@/components/_managebusinessnew/_overview/filterRegisterBusiness.vue'
import filterChangeBusiness from '@/components/_managebusinessnew/_overview/filterChangeBusiness.vue'
import tablebusiness from '@/components/_managebusinessnew/_overview/tablebusiness.vue'
import tableRegisterBusiness from '@/components/_managebusinessnew/_overview/tableRegisterBusiness.vue'
import tableChangeBusiness from '@/components/_managebusinessnew/_overview/tableChangeBusiness.vue'
export default {
  components: {
    titleAgency,
    filterBusiness,
    filterRegisterBusiness,
    filterChangeBusiness,
    tablebusiness,
    tableRegisterBusiness,
    tableChangeBusiness
  },
  data () {
    return {
      activeTab: 0,
      page: 'approve',
      render: true,
      tab: null,
      items: [
        {
          id: 1,
          nameBusiness: 'จัดการธุรกิจ'
        },
        {
          id: 2,
          nameBusiness: 'ลงทะเบียนธุรกิจ'
        },
        {
          id: 3,
          nameBusiness: 'ยื่นเรื่องเปลี่ยนแปลงธุรกิจ'
        }
      ],
      approveRole: localStorage.approveRole
      // items: [
      //   'ธุรกิจ(ร้านค้า)', 'นิติบุคคล'
      // ]
    }
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    // this.getBusinessCount()
  },
  beforeDestroy () {
    EventBus.$off('countBusiness')
    EventBus.$off('setApproveRole')
  },
  mounted () {
    // EventBus.$on('countBusiness', this.getBusinessCount)
    EventBus.$on('setApproveRole', this.setApproveRole)
  },
  tab: function (val) {
    this.forceRerender()
  },
  methods: {
    changeTab (item) {
      this.forceRerender()
    },
    async setApproveRole () {
      this.approveRole = localStorage.approveRole
      // await this.getBusinessCount()
    },
    forceRerender () {
      if (this.activeTab === 0) {
        this.page = 'approve'
        localStorage.setItem('approveRole', 'Admin')
        EventBus.$emit('updateNavbarRole', 'Admin')
      } else if (this.activeTab === 1) {
        this.page = 'acknowledge'
        localStorage.setItem('approveRole', 'Leader')
        EventBus.$emit('updateNavbarRole', 'Leader')
      }
      this.render = false
      this.$nextTick(() => {
        this.render = true
      })
    }
    // ไม่ได้ใช้
    // async getBusinessCount () {
    //   const obj = {
    //     role: this.approveRole
    //   }
    //   try {
    //     await this.axios({
    //       method: 'post',
    //       url: `${this.api}/api/vMonk/companys/countBusinessAndReqBusiness`,
    //       data: obj,
    //       headers: {
    //         authorization: this.tokenUser
    //       }
    //     }).then((response) => {
    //       if (response.data.success) {
    //         // this.items = response.data.result.getBusiness
    //         // this.items.push({
    //         //   id: 3,
    //         //   nameBusiness: 'ยื่นเรื่องเปลี่ยนแปลงธุรกิจ'
    //         // })
    //       } else {
    //         // console.log(response)
    //       }
    //     })
    //   } catch (error) {
    //     console.log(error)
    //   } finally {
    //     this.loading = false
    //   }
    // }
  }
}
</script>

<style scoped>
.v-tab {
  font-family: 'Sarabun', sans-serif !important;
  font-weight: "600";
  font-size: 1.2rem;
}
</style>
